import { API_URL } from '@constants'
import { Heading } from '@components/heading/Heading'
import { replaceImageExtension } from '@utils'
import { useParams } from 'react-router-dom'
import { useDetailContent } from '../../hooks/content/useDetailContent'
import { parseExpertiseHeader } from '../../utils/cmsDetail'
import { ContentStatus } from '../contentStatus/ContentStatus'
import { highlightMarkedText, hideMarkedText } from '@helpers/getMark'
import { Helmet } from 'react-helmet-async'

export interface IExpertisesPages {
    title: string
    blockText1: string
    urlSlug: string
    blockText2?: string
    title2?: string
}

export const ExpertiseDetailHeader = () => {
    const { id } = useParams<{ id: string }>()
    const content = useDetailContent(
        id
            ? `${API_URL}/api/expertises-pages?filters[urlSlug][$eq]=${encodeURIComponent(
                  id
              )}&&populate=*`
            : null,
        parseExpertiseHeader
    )

    if (content.state !== 'success') {
        return (
            <ContentStatus
                state={content.state}
                emptyMessage="Expertise introuvable."
            />
        )
    }
    const expertiseHeader = content.data

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`Listen too | expertise : ${
                    hideMarkedText(expertiseHeader?.title) ?? 'Nos Expertises'
                }`}</title>
                <meta
                    name="description"
                    content={`Découvrez notre expertise en ${
                        hideMarkedText(expertiseHeader?.title) ??
                        'transformation digitale'
                    }. E-commerce, cloud, omnicanal, outils collaboratifs et plus encore.`}
                />
            </Helmet>
            <Heading
                title={highlightMarkedText(expertiseHeader?.title)}
                description={expertiseHeader?.blockText1}
                title2={expertiseHeader?.title2}
                blockText2={expertiseHeader?.blockText2}
                imageUrl={replaceImageExtension(expertiseHeader.image.url)}
                imageAlt={expertiseHeader.image.alternativeText}
            />
        </>
    )
}
